module.exports = __webpack_public_path__ + "img/xiaodanghuishou.b276e1cd.png";